import app from "flarum/forum/app";
import Modal from "flarum/common/components/Modal";
import Button from "flarum/common/components/Button";
/**
 * Says the message is too long, and by exactly how much.
 *
 * A modal rather than an inline note because the send has just been refused:
 * the composer keeps the text, nothing was lost, and the reader needs to know
 * that before they retype it. The count is the actionable part — "shorten by
 * 412" is a instruction, "too long" is a complaint.
 *
 * The alternative this replaces was worse than either: `maxlength` on the
 * textarea, which let the browser silently drop the tail of anything pasted.
 */
export default class MessageTooLongModal extends Modal {
  className() {
    return "ChatModal ChatTooLongModal Modal--small";
  }
  title() {
    return app.translator.trans("ramon-chat.forum.composer.too_long_title");
  }
  content() {
    const _this$attrs = this.attrs,
      length = _this$attrs.length,
      max = _this$attrs.max;
    return m("div", {
      className: "Modal-body ChatTooLongModal-body"
    }, m("p", {
      className: "ChatTooLongModal-text"
    }, app.translator.trans("ramon-chat.forum.composer.too_long_body", {
      over: length - max,
      max
    })), m(Button, {
      className: "Button Button--primary Button--block",
      onclick: () => this.hide()
    }, app.translator.trans("ramon-chat.forum.composer.too_long_dismiss")));
  }
}
flarum.reg.add('ramon-chat', 'forum/components/MessageTooLongModal', MessageTooLongModal);